import React from "react";
import Timeline from "../../components/Timeline";
import resumeTimeline from "../../core/config/resumeTimeline.json";

function TimelineSection() {
    return <Timeline timelineItems={resumeTimeline} />;
}

export default TimelineSection;
